export default {
    index: "Dashboard",
    users: "Users",
    organisations: "Organisations",
    "settings-loginProviders": "Login Methods"
}
